import React from "react";
import {ToastProvider} from "./ToastProvider";

class Toast extends React.Component {
    constructor(props){
        super(props);
    }

    static showMessage(message, options) {
        ToastProvider.showMessage(message, options);
    }

    static close(){
        ToastProvider.snackbarClose();
    }

    render() {
        return(
            <ToastProvider />
        )
    }
}

export { Toast };